export const ROUTES = {
  ROOT: '/shipment/receive',
};

export const COVERED_CITIES = ['RIYADH', 'DAMMAM', 'JEDDAH'];
